import React from 'react';
import { Handle } from 'react-flow-renderer';
import ec2instance from '@/assets/ec2instance.svg';
import ebsvolume from '@/assets/ebsvolume.svg';
import networkinterface from '@/assets/networkinterface.svg';
import ec2subnet from '@/assets/ec2subnet.svg';
import elasticipaddress from '@/assets/elasticipaddress.png';
import EC2SecurityGroup from '@/assets/EC2SecurityGroup.svg';
import hacker from '@/assets/hacker.png';
import s3bucket from '@/assets/s3bucket.svg';

const CustomNode = ({ data }) => {
  // Define mapping between node class and styles (color & icon)
  const labelToStyleMap = {
    ec2instance: { color: '#e87a0b', icon: ec2instance },
    ebsvolume: { color: '#e15343', icon: ebsvolume },
    networkinterface: { color: '#248814', icon: networkinterface },
    ec2subnet: { color: '#6e42c7', icon: ec2subnet },
    elasticipaddress: { color: '#ED7100', icon: elasticipaddress },
    EC2SecurityGroup: { color: '#b30076', icon: EC2SecurityGroup },
    attacker: { color: 'transparent', icon: hacker },
    s3bucket: { color: '#e15141', icon: s3bucket },
  };

  // Find matching class from the label and map to the correct style (color & icon)
  const nodeClass = data.class.toLowerCase(); // Use the lowercase of the label for the class
  const matchingStyle = Object.keys(labelToStyleMap).find(
    key => nodeClass.includes(key.toLowerCase()) // Find the style based on the class
  );

  const nodeStyle = matchingStyle
    ? labelToStyleMap[matchingStyle]
    : { color: '#000000', icon: null }; // Default if not found

  // Check if the node label is "Attacker" to apply special styling (e.g., grayscale, border)
  const isAttacker = data.label.toLowerCase() === 'attacker';

  // Define the CSS styles for the node's container, circle, and label
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '80px',
      height: '80px',
      position: 'relative',
    },
    circle: {
      display: 'flex',
      aspectRatio: '1',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: nodeStyle.color, // Use color from the style map
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      boxShadow: isAttacker ? '0 4px 8px rgba(0, 0, 0, 0.6)' : '0 2px 4px rgba(0, 0, 0, 0.2)',
      border: isAttacker ? '2px solid black' : 'none',
      position: 'relative',
    },
    svgLogo: {
      width: '20px',
      height: '20px',
      filter: isAttacker ? 'grayscale(1)' : 'invert(1)', // Grayscale if attacker
    },
    label: {
      marginTop: '8px',
      fontSize: '12px',
      color: '#333333',
      textAlign: 'center',
    },
    hiddenHandle: {
      visibility: 'hidden',
      width: '8px',
      height: '8px',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.circle}>
        {/* Dynamically render the icon */}
        {nodeStyle.icon && <img src={nodeStyle.icon} alt="Node Logo" style={styles.svgLogo} />}
        {/* Hidden Handles */}
        <Handle type="source" position="right" style={styles.hiddenHandle} />
        <Handle type="target" position="left" style={styles.hiddenHandle} />
      </div>
      {/* Display the original label */}
      <span style={styles.label}>{data.label}</span>
    </div>
  );
};

export default CustomNode;
